/* import __COLOCATED_TEMPLATE__ from './parent-category-row-optimized.hbs'; */
import CategoryListItem from "discourse/components/category-list-item";

export default class ParentCategoryRowOptimized extends CategoryListItem {}
